import { ChangeDetectionStrategy, Component, input, model, output } from "@angular/core";

import { NzTooltipDirective } from "ng-zorro-antd/tooltip";
import { NzPopoverModule } from "ng-zorro-antd/popover";

import { LktAvatarComponent } from "../avatar/avatar.component";
import { LktChipComponent } from "../chip/chip.component";

import { UserPopoverItem } from "./user-popover-item.interface";

@Component({
  selector: "lkt-user-popover",
  standalone: true,
  imports: [NzPopoverModule, LktAvatarComponent, LktChipComponent, NzTooltipDirective],
  templateUrl: "./user-popover.component.html",
  styleUrl: "./user-popover.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LktUserPopoverComponent {
  public readonly userName = input<string>("Usuário");
  public readonly userAvatar = input<string>("");
  public readonly avatarSize = input<"small" | "medium" | "large" | "x-small">("x-small");
  public readonly profileLabel = input<string>("Administrador Lekto");
  public readonly profileIcon = input<string>("uil uil-setting");
  public readonly hasMultipleProfiles = input<boolean>(false);
  /** Modo compacto (rail icon-only): exibe apenas o avatar, sem o nome. */
  public readonly compact = input<boolean>(false);
  public readonly items = input<UserPopoverItem[]>([]);
  public readonly version = input<string>("3.0");
  public readonly dataCy = input<string>("user-popover-trigger");

  public readonly itemClick = output<string>();
  public readonly switchProfileClick = output<void>();

  /**
   * Visibilidade controlável pelo pai, para que abrir outro painel possa fechar este
   * (ver a coordenação em `LktSidebarMenuComponent`). O `model()` já expõe o output
   * `visibleChange`; escrever aqui pela binding não reemite, então não há reentrância.
   */
  public readonly visible = model<boolean>(false);

  public onVisibleChange(visible: boolean): void {
    this.visible.set(visible);
  }

  public onItemClick(itemId: string): void {
    this.itemClick.emit(itemId);
    this.visible.set(false);
  }

  public onSwitchProfile(): void {
    this.switchProfileClick.emit();
    this.visible.set(false);
  }
}
